import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_RESIDENT_REPORT, CREATING_RESIDENT_REPORT, GET_RESIDENT_REPORTS, GETTING_RESIDENT_REPORTS, RESIDENT_REPORTS_ERROR } from "../types"

export const createResidentReport = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_RESIDENT_REPORT,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/resident-reports`, payload, { headers })
        
        dispatch({
            type: CREATE_RESIDENT_REPORT,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: RESIDENT_REPORTS_ERROR,
            error
        })
    }
}

export const clearCreatedResidentReport = () => async (dispatch) => {    
    dispatch({
        type: CREATE_RESIDENT_REPORT,
        payload: null
    })
}

export const fetchResidentReports = (residentId, filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/resident-reports?resident=${residentId}&expand=activities,notes,createdBy,handoverTo`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_RESIDENT_REPORTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_RESIDENT_REPORTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: RESIDENT_REPORTS_ERROR,
            error
        })
    }
}
